import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/Login.vue'
import Layout from '@/layout/Index.vue'
import Dashboard from '@/views/Dashboard.vue'
import { usePermissionStore } from '@/store/permission'
import { generateRoutes } from './dynamic'

// 保留现有的静态导入作为后备方案
import ProductList from '@/views/product/List.vue'
import ProductCreate from '@/views/product/Create.vue'
import ProductEdit from '@/views/product/Edit.vue'
import StockIn from '@/views/stock/In.vue'
import StockOut from '@/views/stock/Out.vue'
import StockAdjust from '@/views/stock/Adjust.vue'
import StockMovements from '@/views/stock/Movements.vue'
import StockStatistics from '@/views/stock/Statistics.vue'
import StockMonthlySummary from '@/views/stock/MonthlySummary.vue'
import StockDailySummary from '@/views/stock/DailySummary.vue'
import Warehouse from '@/views/stock/Warehouse.vue'
import Categories from '@/views/basedata/Categories.vue'
import Attributes from '@/views/basedata/Attributes.vue'
import FinancialCategories from '@/views/basedata/FinancialCategories.vue'
import FinancialRecords from '@/views/financial/Records.vue'
import FinancialEdit from '@/views/financial/Edit.vue'
import DailySummary from '@/views/financial/DailySummary.vue'
import MonthlySummary from '@/views/financial/MonthlySummary.vue'
import CategorySummary from '@/views/financial/CategorySummary.vue'
import AnnualSummary from '@/views/financial/AnnualSummary.vue'
import Factory from '@/views/basedata/Factory.vue'
import PreProductionList from '@/views/production/PreProductionList.vue'
import PreProductionCreate from '@/views/production/PreProductionCreate.vue'
import PreProductionDetail from '@/views/production/PreProductionDetail.vue'
import SampleList from '@/views/production/SampleList.vue'
import CompletionRecordList from '@/views/production/CompletionRecordList.vue'
import MaterialList from '@/views/material/MaterialList.vue'
import MaterialPurchaseList from '@/views/material/PurchaseList.vue'
import MaterialUsageList from '@/views/material/UsageList.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '首页' }
      },
      {
        path: 'products',
        name: 'ProductList',
        component: ProductList,
        meta: { title: '商品列表' }
      },
      {
        path: 'products/create',
        name: 'ProductCreate',
        component: ProductCreate,
        meta: { title: '创建商品' }
      },
      {
        path: 'products/edit/:id',
        name: 'ProductEdit',
        component: ProductEdit,
        meta: { title: '编辑商品' }
      },
      {
        path: 'stock/in',
        name: 'StockIn',
        component: StockIn,
        meta: { title: '库存入库' }
      },
      {
        path: 'stock/out',
        name: 'StockOut',
        component: StockOut,
        meta: { title: '库存出库' }
      },
      {
        path: 'stock/adjust',
        name: 'StockAdjust',
        component: StockAdjust,
        meta: { title: '库存调整' }
      },
      {
        path: 'stock/movements',
        name: 'StockMovements',
        component: StockMovements,
        meta: { title: '出入库记录' }
      },
      {
        path: 'stock/statistics',
        name: 'StockStatistics',
        component: StockStatistics,
        meta: { title: '出入库统计' }
      },
      {
        path: 'stock/monthly-summary',
        name: 'StockMonthlySummary',
        component: StockMonthlySummary,
        meta: { title: '月度汇总' }
      },
      {
        path: 'stock/daily-summary',
        name: 'StockDailySummary',
        component: StockDailySummary,
        meta: { title: '日汇总' }
      },
      {
        path: 'stock/warehouse',
        name: 'Warehouse',
        component: Warehouse,
        meta: { title: '仓库管理' }
      },
      {
        path: 'financial/records',
        name: 'FinancialRecords',
        component: FinancialRecords,
        meta: { title: '财务记录' }
      },
      {
        path: 'financial/edit',
        name: 'FinancialCreate',
        component: FinancialEdit,
        meta: { title: '新增财务记录' }
      },
      {
        path: 'financial/edit/:id',
        name: 'FinancialEdit',
        component: FinancialEdit,
        meta: { title: '编辑财务记录' }
      },
      {
        path: 'financial/daily-summary',
        name: 'DailySummary',
        component: DailySummary,
        meta: { title: '每日汇总' }
      },
      {
        path: 'financial/monthly-summary',
        name: 'MonthlySummary',
        component: MonthlySummary,
        meta: { title: '每月汇总' }
      },
      {
        path: 'financial/annual-summary',
        name: 'AnnualSummary',
        component: AnnualSummary,
        meta: { title: '年汇总' }
      },
      {
        path: 'financial/category-summary',
        name: 'CategorySummary',
        component: CategorySummary,
        meta: { title: '分类汇总' }
      },
      {
        path: 'basedata/categories',
        name: 'Categories',
        component: Categories,
        meta: { title: '商品分类' }
      },
      {
        path: 'basedata/attributes',
        name: 'Attributes',
        component: Attributes,
        meta: { title: '商品属性' }
      },
      {
        path: 'basedata/financial-categories',
        name: 'FinancialCategories',
        component: FinancialCategories,
        meta: { title: '收支分类' }
      },
      {
        path: 'production/factory',
        name: 'Factory',
        component: Factory,
        meta: { title: '工厂管理' }
      },
      {
        path: 'production/preproduction',
        name: 'PreProductionList',
        component: PreProductionList,
        meta: { title: '预生产订单管理' }
      },
      {
        path: 'production/preproduction/create',
        name: 'PreProductionCreate',
        component: PreProductionCreate,
        meta: { title: '创建预生产订单' }
      },
      {
        path: 'production/preproduction/detail/:id',
        name: 'PreProductionDetail',
        component: PreProductionDetail,
        meta: { title: '预生产订单详情' }
      },
      {
        path: 'production/sample',
        name: 'SampleList',
        component: SampleList,
        meta: { title: '样衣记录' }
      },
      {
        path: 'production/completion-records',
        name: 'CompletionRecordList',
        component: CompletionRecordList,
        meta: { title: '生产入库记录' }
      },
      {
        path: 'material/list',
        name: 'MaterialList',
        component: MaterialList,
        meta: { title: '原料列表' }
      },
      {
        path: 'material/purchase',
        name: 'MaterialPurchaseList',
        component: MaterialPurchaseList,
        meta: { title: '原料采购' }
      },
      {
        path: 'material/usage',
        name: 'MaterialUsageList',
        component: MaterialUsageList,
        meta: { title: '原料使用' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 是否正在添加动态路由
let isAddingRoutes = false

router.beforeEach(async (to, from, next) => {
  const sessionId = localStorage.getItem('sessionId')

  // 未登录，跳转到登录页
  if (to.meta.requiresAuth !== false && !sessionId) {
    return next('/login')
  }

  // 已登录，访问登录页，跳转到首页
  if (to.path === '/login' && sessionId) {
    return next('/')
  }

  // 已登录，检查是否需要加载权限
  if (sessionId && to.meta.requiresAuth !== false) {
    const permissionStore = usePermissionStore()

    // 如果权限未加载，先加载权限
    if (!permissionStore.isLoaded && !isAddingRoutes) {
      isAddingRoutes = true
      try {
        const permData = await permissionStore.loadUserPermissions()

        // 根据权限生成动态路由
        if (permData && permData.menus) {
          const dynamicRoutes = generateRoutes(permData.menus)

          // 将动态路由作为 Layout 的子路由添加
          dynamicRoutes.forEach(route => {
            // 使用 Layout 的名称来添加子路由
            router.addRoute('Layout', route)
          })
        }

        isAddingRoutes = false
        // 重新导航到目标路由
        return next({ ...to, replace: true })
      } catch (error) {
        console.error('加载权限失败:', error)
        isAddingRoutes = false
        // 权限加载失败，清除登录信息，跳转到登录页
        localStorage.removeItem('sessionId')
        localStorage.removeItem('userId')
        localStorage.removeItem('userInfo')
        return next('/login')
      }
    }
  }

  next()
})

export default router